import { PhoneNumber } from '@weave/schema-gen-ts/dist/phonenumbers/phonenumber.pb';
import { formatPhoneNumberE164 } from '@frontend/phone-numbers';

export const formatProtobufPhone = (phone: PhoneNumber): string | undefined => {
  const unformattedNumber = phone.nationalNumber;
  if (unformattedNumber === undefined) {
    return undefined;
  }
  const unformattedString = String(unformattedNumber);
  if (!unformattedString) {
    return undefined;
  }

  return formatPhoneNumberE164(unformattedString);
};
